<template>
    <div>
        <div class="position-relative" v-if="product.available_for_order">
            <div class="shop-single-item__price price-style d-767-none mb-4">
                <span>€</span> <span>{{ price }}</span>
            </div>

            <div class="d-flex w-100 flex-column product-selects mt-2">
                <div v-if="years != null && typeof years != 'undefined' && years.length > 0" class="shop-single-item__select-box mb-3">
                    <select class="shop-type-select mr-3" @change="selectYear($event.target.value)">
                        <option v-for="(year, index) in years" :key="index" :value="year.value" v-text="year.name" :selected="selected_year == year.value"></option>
                    </select>
                </div>

                <div v-if="typeof formats != 'undefined' && formats.length > 0" class="shop-single-item__select-box">
                    <select class="shop-type-select" @change="selectFormat($event.target.value)">
                        <option
                            v-for="(format, index) in formats"
                            :key="index"
                            :value="format.value"
                            v-text="product.type != 'gift-card' ? format.name : $root.translateString('gift-amount') + ': ' + format.name"
                            :selected="selected_format == format.value"></option>
                    </select>
                </div>
            </div>

            <div class="shop-single-item__add-to-cart" v-if="isBuyableByGuest">
                <div class="shop-single-item__add-quantity quantity-btns">
                    <div class="quantity-btns__minus">
                        <img @click="decreaseQty" src="/images/svg/roeno-04.svg" alt="icona" />
                    </div>

                    <div class="quantity-btns__input">
                        <input readonly type="number" min="1" v-model="buy.qty" />
                    </div>

                    <div class="quantity-btns__plus">
                        <img @click="increaseQty" src="/images/svg/roeno-05.svg" alt="icona" />
                    </div>
                </div>

                <div class="shop-single-item__price price-style d-768-none">
                    <span>€</span> <span>{{ price }}</span>
                </div>

                <div class="shop-single-item__add-btn d-767-none">
                    <div class="brand-btn">
                        <a @click="addToCart" class="full" href="javascript:void(0)"
                            ><span>{{ $root.translateString("add_to_cart") }}</span></a
                        >
                    </div>
                </div>
            </div>
            <div class="shop-single-item__add-to-cart mb-4 mt-4 mt-md-0" v-else>
                <div class="small-banner d-flex align-items-center p-3 mt-n4 bg-white">
                    <h6 class="flex-grow-1 font-serif text-bigger d-flex flex-column" style="line-height: 1.1" v-if="lang == 'it'">
                        Per poter acquistare quest'annata devi essere iscritto al nostro Wine Club. Iscriviti ora, è semplice e completamente gratuito: potrai accedere ad annate, visite esclusive e tanto altro ancora!
                        <a class="text-gold w-100 mt-3" href="javascript:void(0)" @click="summonPopup">Iscriviti al Wine Club</a>
                    </h6>
                    <h6 class="flex-grow-1 font-serif text-bigger d-flex flex-column" style="line-height: 1.1" v-else>
                        To be able to buy this vintage you must be registered in our Wine Club. Sign up now, it's simple and completely free: you will be able to access vintages, exclusive visits and much more!
                        <a class="text-gold w-100 mt-3" href="javascript:void(0)" @click="summonPopup"> Join the Wine Club </a>
                    </h6>
                </div>
            </div>

            <div class="shop-single-item__add-btn d-768-none" v-if="isBuyableByGuest">
                <div class="brand-btn">
                    <a @click="addToCart" class="full" href="javascript:void(0)"
                        ><span>{{ $root.translateString("add_to_cart") }}</span></a
                    >
                </div>
            </div>

            <p class="added-to-cart mt-3 d-inline-block text-center w-100" v-if="added_to_cart">
                <span>{{ $root.translateString("added_to_cart") }}</span>
            </p>
        </div>

        <div class="position-relative" v-else>
            <div class="prodotto-quantity no-before">
                <p class="text-gold mb-5 text-center text-lg-left w-100">- {{ $root.translateString("not_available") }} -</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["productProp", "qsFormat", "qsYear", "qsAdwordsProp", "lang", "isLogged", "showRecycle"],
        data() {
            return {
                main_selector: "year",
                default_format: "bottiglia",
                default_year: "",
                selected_code: "",
                selected_format: "",
                selected_year: "",
                product: null,
                qsAdwords: typeof this.qsAdwordsProp != "undefined" ? this.qsAdwordsProp : null,
                guest_vintage: 0,
                is_logged: false,
                combinations: {},
                socialProductId: "",
                formats: [],
                years: [],
                buy: {
                    type: "product",
                    id: null,
                    qty: 1,
                },
                added_to_cart: false,
            };
        },
        created() {
            this.product = this.productProp;

            if (this.product.type == "vini") {
                this.buy.qty = 1;
            }

            if (this.isLogged) {
                this.is_logged = true;
            }

            if (["accessori", "sapori", "cofanetti", "gift-card"].includes(this.product.type)) {
                this.default_format = this.product.combinations[0].code;
                this.main_selector = this.product.combinations[0].code;
            }

            if (this.product.combinations.length > 0) {
                this.product.combinations.sort(function (a, b) {
                    return parseFloat(a.price) - parseFloat(b.price);
                });
            }

            this.buy.id = this.product.id;

            let tmp_first_format = "";
            let default_format_exist = false;
            let tmp_formats = [];

            let tmp_first_year = "";
            let default_year_exist = false;
            let tmp_years = [];

            for (let [key, combination] of Object.entries(this.product.combinations)) {
                let weight = 1;

                if (typeof combination.weight != "undefined") {
                    weight = parseFloat(combination.weight);
                }

                this.combinations[combination.code] = {
                    code: combination.code,
                    price: combination.price,
                    weight: weight,
                    attributes: {},
                };

                if (combination.attributes.length > 0) {
                    for (let attribute of combination.attributes) {
                        this.combinations[combination.code].attributes[attribute.key] = attribute;

                        if (attribute.key == "formato" && !tmp_formats.includes(attribute.value)) {
                            if (key == 0) {
                                tmp_first_format = attribute.value;
                            }

                            if (attribute.value == this.default_format) {
                                default_format_exist = true;
                            }

                            tmp_formats.push(attribute.value);

                            this.formats.push({
                                value: attribute.value,
                                name: attribute.value_label,
                                combination: combination.code,
                            });
                        }

                        if (attribute.key == "anno" && !tmp_years.includes(parseInt(attribute.value))) {
                            if (tmp_first_year < parseInt(attribute.value)) {
                                tmp_first_year = parseInt(attribute.value);
                            }

                            if (parseInt(attribute.value) == parseInt(this.default_year)) {
                                default_year_exist = true;
                            }

                            tmp_years.push(parseInt(attribute.value));

                            this.years.push({
                                value: parseInt(attribute.value),
                                name: attribute.value_label,
                                combination: combination.code,
                            });
                        }
                    }
                }
            }

            this.years.sort(function (a, b) {
                return parseFloat(b.value) - parseFloat(a.value);
            });

            /**/

            //select wine from querystring

            if (this.product.type == "vini") {
                if (typeof this.qsFormat != "undefined" && this.qsYear != "undefined") {
                    if (this.qsYear != null && tmp_years.includes(parseInt(this.qsYear))) {
                        this.selectYear(parseInt(this.qsYear));
                    } else {
                        if (default_year_exist == true) {
                            this.selectYear(this.default_year);
                        } else {
                            this.selectYear(tmp_first_year);
                        }
                    }

                    if (this.qsFormat != null && tmp_formats.includes(this.qsFormat)) {
                        this.selectFormat(this.qsFormat.toLowerCase());
                    } else {
                        if (default_format_exist == true) {
                            this.selectFormat(this.default_format);
                        } else {
                            this.selectFormat(tmp_first_format);
                        }
                    }
                }
            }
        },
        mounted() {
            this.socialProductId = this.product.id + "_" + this.product.link_rewrite + "_";
            if (this.selected_code != null) {
                this.socialProductId += this.selected_code;
            }

            fbq("track", "ViewContent", {
                value: parseFloat(this.price),
                currency: "EUR",
                content_ids: this.socialProductId,
                content_type: "product",
                content_name: this.product.name,
            });

            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                    items: [
                        {
                            item_name: this.product.name.replace("<br>", " "),
                            item_id: this.socialProductId,
                            price: this.$root.currencyDisplayGtm(this.price),
                            item_brand: "Cantina Roeno",
                            quantity: 1,
                            item_category: this.type,
                            item_variant: this.selected_format + " - " + this.selected_year,
                        },
                    ],
                },
            });

            if (this.product.type == "vini") {
                this.product.combinations.forEach((elem) => {
                    let split = elem.code.split("-");
                    if (split[0].toLowerCase() == "bottiglia") {
                        if (this.guest_vintage < parseInt(split[1])) {
                            this.guest_vintage = parseInt(split[1]);
                        }
                    }
                });
            }
        },
        methods: {
            decreaseQty() {
                if (this.buy.qty > 1) {
                    this.buy.qty -= 1;
                } else {
                    this.buy.qty = 1;
                }
            },
            increaseQty() {
                if (this.buy.qty < 30) {
                    this.buy.qty += 1;
                } else {
                    this.buy.qty = 30;
                }
            },
            summonPopup() {
                this.$eventHub.$emit("register", {});
            },
            selectFormat(format) {
                if (this.main_selector == "formato") {
                    this.years = [];
                    for (let [k, c] of Object.entries(this.combinations)) {
                        if (c.attributes.formato.value == format) {
                            //console.log(c);
                            if (typeof c.attributes.anno != "undefined") {
                                this.years.push({
                                    value: c.attributes.anno.value,
                                    name: c.attributes.anno.value_label,
                                    combination: c.code,
                                });
                            } else {
                                //se non abbiamo l'anno è singola.
                                this.selected_code = c.code;
                            }
                        }
                    }

                    if (this.years.length > 0) {
                        this.selected_year = this.years[0].value;
                        this.selected_code = this.years[0].combination;
                    } else {
                        this.selected_year = null;
                    }
                } else {
                    this.formats.forEach((y) => {
                        if (y.value == format) {
                            this.selected_code = y.combination;
                        }
                    });
                }

                this.selected_format = format;

                let format_qs = "?format=" + this.selected_format;
                let year_qs = "&year=" + this.selected_year;
                if (this.selected_format == "") {
                    format_qs = "";
                }
                if (this.selected_year == "") {
                    year_qs = "";
                }
                if (this.qsAdwords == null && this.product.type == "vini" && this.showRecycle == false) {
                    if (this.product.category != null) {
                        history.replaceState({}, this.product.name, "/" + this.lang + "/shop/" + this.$root.slugifyType(this.lang, this.product.type) + "/" + this.product.category + "/" + this.product.link_rewrite + format_qs + year_qs);
                    } else {
                        history.replaceState({}, this.product.name, "/" + this.lang + "/shop/" + this.$root.slugifyType(this.lang, this.product.type) + "/" + this.product.link_rewrite + format_qs + year_qs);
                    }
                }

                if (typeof this.qsAdwords != null) {
                    this.qsAdwords = null;
                }
            },
            selectYear(year) {
                this.formats = [];
                let local_default_format_exist = null;
                if (this.main_selector == "year") {
                    for (let [k, c] of Object.entries(this.combinations)) {
                        if (c.attributes.anno.value == year) {
                            //console.log(c);
                            if (typeof c.attributes.anno != "undefined") {
                                this.formats.push({
                                    value: c.attributes.formato.value,
                                    name: c.attributes.formato.value_label,
                                    combination: c.code,
                                });
                                if (typeof this.default_format != "undefined" && this.default_format != null) {
                                    if (c.attributes.formato.value === this.default_format) {
                                        local_default_format_exist = {
                                            value: c.attributes.formato.value,
                                            combination: c.code,
                                        };
                                    }
                                }
                            } else {
                                //se non abbiamo il formato è singola.
                                this.selected_code = c.code;
                            }
                        }
                    }

                    if (this.formats.length > 0) {
                        if (local_default_format_exist !== null) {
                            this.selected_format = local_default_format_exist.value;
                            this.selected_code = local_default_format_exist.combination;
                        } else {
                            this.selected_format = this.formats[0].value;
                            this.selected_code = this.formats[0].combination;
                        }
                    } else {
                        this.selected_year = null;
                    }
                } else {
                    this.years.forEach((y) => {
                        if (y.value == year) {
                            this.selected_code = y.combination;
                        }
                    });
                }

                this.selected_year = year;
                if (this.qsAdwords == null && this.product.type == "vini" && this.showRecycle == false) {
                    if (this.product.category != null) {
                        history.replaceState(
                            {},
                            this.product.name,
                            "/" +
                                this.lang +
                                "/shop/" +
                                this.$root.slugifyType(this.lang, this.product.type) +
                                "/" +
                                this.product.category +
                                "/" +
                                this.product.link_rewrite +
                                "?format=" +
                                this.selected_format +
                                "&year=" +
                                this.selected_year
                        );
                    } else {
                        history.replaceState(
                            {},
                            this.product.name,
                            "/" + this.lang + "/shop/" + this.$root.slugifyType(this.lang, this.product.type) + "/" + this.product.link_rewrite + "?format=" + this.selected_format + "&year=" + this.selected_year
                        );
                    }
                }
            },
            addToCart() {
                this.buy.combination = this.combinations[this.selected_code];

                if (["accessori", "sapori", "gift-card"].includes(this.product.type)) {
                    this.buy.combination.attributes = [];
                }

                axios
                    .post("/api/cart/add", this.buy)
                    .then((response) => {
                        if (response.data.status === true) {
                            fbq("track", "AddToCart", {
                                value: parseFloat(this.price),
                                currency: "EUR",
                                contents: [
                                    {
                                        id: this.socialProductId,
                                        quantity: this.buy.qty,
                                    },
                                ],
                                content_type: "product",
                                content_name: this.product.name,
                            });

                            dataLayer.push({ ecommerce: null });
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: this.product.name.replace("<br>", " "),
                                            item_id: this.socialProductId,
                                            price: this.$root.currencyDisplayGtm(this.price),
                                            item_brand: "Cantina Roeno",
                                            item_category: this.type,
                                            item_variant: this.selected_format + " - " + this.selected_year,
                                            quantity: this.buy.qty,
                                        },
                                    ],
                                },
                            });

                            let buy_qty_memo = this.buy.qty;
                            this.$eventHub.$emit("cart.added", {
                                count: response.data.count,
                                specific_count: buy_qty_memo,
                                product_id: this.product.id,
                                product_code: this.selected_code,
                            });

                            if ($(window).width() >= 992) {
                                this.$eventHub.$emit("cart.show", {});
                            }

                            this.added_to_cart = true;
                            if (this.product.type == "vini") {
                                this.buy.qty = 1;
                            } else {
                                this.buy.qty = 1;
                            }
                            this.buy.combination = null;
                            this.selectFormat(this.default_format);
                            setTimeout(() => {
                                this.added_to_cart = false;
                            }, 4000);
                        }
                    })
                    .catch((err) => {
                        //console.log('Error');
                    });
            },
        },
        computed: {
            isBuyableByGuest() {
                if (this.product.type != "vini" || this.is_logged) {
                    return true;
                }
                return this.selected_year == this.guest_vintage && this.selected_format == "bottiglia";
            },
            price() {
                if (this.selected_code == "") {
                    this.selected_code = this.default_format;
                }

                let base = 0;
                if (typeof this.combinations[this.selected_code] != "undefined") {
                    base = this.combinations[this.selected_code].price;
                }

                let qty = this.buy.qty;
                //let qty = 1;
                /*if(this.product.type == 'vini') {
                qty = 1;
            }*/
                return this.$root.currencyDisplaySimple(base * qty);
            },
        },
    };
</script>
